import { Marked, marked } from 'marked';
import { gfmHeadingId } from 'marked-gfm-heading-id';
import { mangle } from 'marked-mangle';
import sanitizeHtml from 'sanitize-html';

marked.use(mangle());
marked.use(gfmHeadingId());

const renderMarkdown = (text: string, openLinksInNewTab: boolean = true, useMangle: boolean = true) => {
    let rawHtml = marked.parse(text);
    if (!useMangle) {
        const localMarked = new Marked(gfmHeadingId());
        rawHtml = localMarked.parse(text);
    }

    const html = sanitizeHtml(rawHtml, {
        allowedTags: [
            'span',
            'a',
            'p',
            'ul',
            'li',
            'ol',
            'em',
            'h1',
            'h2',
            'a',
            'strong',
            'b',
            'img',
            'del',
            'hr',
            'div',
            'br',
        ],
        allowedAttributes: {
            img: ['src', 'srcset', 'alt', 'title', 'width', 'height', 'loading'],
            '*': ['style', 'start', 'href', 'target', 'rel'],
        },

        transformTags: {
            a: (tagName, originalAttribs) => {
                const attribs = { ...originalAttribs };

                if (openLinksInNewTab) {
                    attribs.target = '_blank';
                    attribs.rel = 'noopener noreferrer';
                }

                return { tagName, attribs };
            },
        },
    });

    // eslint-disable-next-line react/no-danger
    return <div dangerouslySetInnerHTML={{ __html: html }} />;
};
export default renderMarkdown;
